module.exports = __webpack_public_path__ + "static/img/bannerTPL.5e6dc10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/bannerTPL.jpg
// module id = NknN
// module chunks = 4